import { AbstractControl, FormGroup, ValidatorFn, FormControl } from '@angular/forms';
  
export function passwordValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        if(control.value){
            if(control.value.length < 8){
                return {passwordValidationFailed: true, 
                        passwordValidationType: 'passwordValidationErrorPwdLength'
                        }; 
            }else if(control.value.search(/[a-z]/i) < 0){
                return {passwordValidationFailed: true, 
                        passwordValidationType: 'passwordValidationErrorPwdLetter'
                        };
            }else if(control.value.search(/[0-9]/) < 0){
                return {passwordValidationFailed: true, 
                        passwordValidationType: 'passwordValidationErrorPwdDigit'
                        }
            }else{
                return null;
            }
        }

        return null;
    };
}